import { useState, useEffect } from 'react';

export function useNetworkStatus() {
	const [isOnline, setIsOnline] = useState(() => {
		if (typeof navigator !== 'undefined') {
			return navigator.onLine;
		}
		return true;
	});

	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);

		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);

		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	return isOnline;
}
